import { render, staticRenderFns } from "./CategoryOrganizationsView.vue?vue&type=template&id=7d206338&scoped=true&"
import script from "./CategoryOrganizationsView.vue?vue&type=script&lang=js&"
export * from "./CategoryOrganizationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d206338",
  null
  
)

export default component.exports